import { cn } from '@/utils/cn';
import React from 'react';

function SnackBarWrapper({ children, openModal, className = '' }) {
  return (
    <div
      className={cn(
        'snackbar-wrapper w-full min-h-[60px] flex items-end justify-center opacity-30 fixed bottom-full left-0 right-0 transition-opacity duration-100',
        {
          '!bottom-0 !opacity-100 !z-[701000]': openModal,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}

export default SnackBarWrapper;
